<div class="zwi-flex-center zwi-block-section--horizontal">
  <zwi-book-menu [book]="(selectedBook$ | async)" (bookSelected)="onBookSelected($event)"></zwi-book-menu>
  @if ((selectedBook$ | async) !== null) {
    <button (click)="removeSelected()" mat-button color="primary" class="zwi-ml-md">All Books</button>
  }
</div>
@for (b of bookSermons | async; track b) {
  <div>
    <zwi-sermon-category-row>{{ toBook(b.book) }}</zwi-sermon-category-row>
    @if (b.sermons.length > 0) {
      <zwi-sermon-list [bookmarkable]="bookmarkable" [sermons]="b.sermons" [sortBy]="'airDate'" (starChange)="favoriteChange($event)"></zwi-sermon-list>
    } @else {
      <div class="headline--blank">{{ blankMessage(b.book) }}</div>
    }
  </div>
}
